<template>
    <div class="border-2 border-border rounded-xl flex flex-col">
        <div class="flex flex-row justify-between items-center gap-2 p-2.5">
            <div class="flex flex-col gap-1 font-normal body-small overflow-x-hidden">
                <div class="text-ink capitalize">{{ t("components.calendar.disconnect.integration", { provider: calendarIntegration?.calendar_provider }) }}</div>
                <div class="text-ink-muted text-ellipsis whitespace-nowrap overflow-hidden">{{ userDetails?.email }}</div>
            </div>
            <BaseButton
                v-if="userDetails.has_calendar_integration && !confirming"
                theme="tertiary"
                class="shrink-0"
                :class="{ 'font-medium': !tonalThemeEnabled }"
                @click="confirming = true">
                {{ t("components.calendar.disconnect.disconnect") }}
            </BaseButton>
        </div>
        <InlineConfirm
            v-model:open="confirming"
            :prompt="t('components.calendar.disconnect.prompt')"
            :confirm-label="t('components.calendar.disconnect.confirm')"
            :is-confirming="isDisconnecting"
            @confirm="removeCalendarIntegration" />
    </div>
</template>

<script setup>
import { router } from "@inertiajs/vue3";
import { useFetch } from "~vue/api";
import BaseButton from "~vue/components/BaseButton.vue";
import InlineConfirm from "~vue/components/InlineConfirm.vue";
import { logUserInteraction } from "~vue/utils/logUtils";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { inject, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const userDetails = inject("user_details");
const calendarIntegration = inject("calendarIntegration");
// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.

const confirming = ref(false);

const { execute: executeRemoveIntegration, isFetching: isDisconnecting, onFetchResponse } = useFetch("/api/calendar_integration/", { immediate: false }).delete();

const removeCalendarIntegration = async () => {
    await executeRemoveIntegration();
    logUserInteraction("calendar_integration_disconnected");
};

onFetchResponse(() => {
    router.reload({ only: ["user_details"] });
    confirming.value = false;
});
</script>

<style scoped></style>
